export class Html5Module {
  private el: HTMLElement;
  private abortController: AbortController;
  private iframes: NodeListOf<HTMLIFrameElement>;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
    this.iframes = this.el.querySelectorAll<HTMLIFrameElement>("iframe");
  }

  init(): void {
    document.addEventListener("viewportChange", this.handleViewportChange as EventListener, { signal: this.abortController.signal });
    this.initHeight();
  }

  private handleViewportChange = (event: Event): void => {
    this.setHeight((event as CustomEvent).detail);
  };

  private initHeight(): void {
    const htmlClasses = document.documentElement.className;
    let viewportSize = "small";

    if (htmlClasses.indexOf("medium") > 0) {
      viewportSize = "medium";
    } else if (htmlClasses.indexOf("large") > 0) {
      viewportSize = "large";
    }

    this.setHeight({ query: { name: viewportSize } });
  }

  private setHeight(data?: { query: { name: string } }): void {
    if (!data) return;

    let viewportSize = "small";
    if (data.query.name === "medium") {
      viewportSize = "medium";
    } else if (data.query.name === "large" || data.query.name === "xlarge") {
      viewportSize = "large";
    }

    this.iframes.forEach((iframe) => {
      const height = iframe.getAttribute(`data-height-${viewportSize}`);
      if (height !== null) {
        iframe.style.height = height + "px";
      }
    });
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="html5module"]')
      .forEach((el) => {
        new Html5Module(el).init();
      });
  }
}
